// One place for human-readable dates, so every page formats them the same way
// (Arabic month names and numerals, matching the view counts elsewhere).
export function formatDate(iso) {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('ar', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
        return iso;
    }
}

// True when two timestamps fall on the same calendar day — used to avoid
// showing "published 11 Oct · updated 11 Oct".
export function sameDay(a, b) {
    if (!a || !b) return false;
    return new Date(a).toDateString() === new Date(b).toDateString();
}
